export const breadcrumbStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  mt: '4px',
  mb: '16px',
};

export const breadcrumbPrefixStyles = {
  whiteSpace: 'pre',
};
